import fr from 'facet-rest';
import React from 'react';
import {
  FDBodyText,
  FDHeadlineText,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs } from 'Helpers/Testing';
import {
  CustomGoalItem,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSelection/components/CustomGoalSection/components/CustomGoal';
import GoalSelectionOverride from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSelection/MetaOverride';


function CustomGoalsSection({ resources, onDelete }) {
  const { displayErrorMessage } = useSnackbarContext();

  if (resources.length === 0) {
    return null;
  }

  const handleSubmit = async (item) => {
    try {
      await item.submit();
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to update custom goal');
    }
  };

  return (
    <FDStack direction={'column'} spacing={2} {...dataAttrs('onboarding-custom-goal-section')} width={'100%'}>
      <FDHeadlineText size={'sm'} value={'Custom Goals'} color={'textSecondary'} />
      <FDBodyText color={'textDisabled'} value={'e.g., a gourmet pickle truck, a dream vacation, or a treehouse village.'} />
      <FDStack direction={'column'} spacing={2}>
        {resources.map((item) => {
          return (
            <MetaResourceRenderer
              key={item.instanceId()}
              resource={item}
              layout={CustomGoalItem}
              metaOverrideSet={GoalSelectionOverride}
              LayoutProps={{
                onDelete: async () => onDelete(item),
                onBlur: handleSubmit,
              }}
            />
          );
        })}
      </FDStack>
    </FDStack>
  );
}

CustomGoalsSection.propTypes = {
  resources: PropTypes.arrayOf(fr.Resource).isRequired,
};

CustomGoalsSection.defaultProps = {
};

export { CustomGoalsSection };
